<template>
  <div class="relative flex items-center justify-start shrink-0" :class="[sizeClasses]">
    <BaseMemberAvatar :member="member" :size="size" />
    <FeedbackArrow v-if="type" :type="type" />
  </div>
</template>
<script lang="ts" setup>
import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'

import FeedbackArrow from './FeedbackArrow.vue'
import { computed } from 'vue'
import type { AvatarMemberAttributes, AvatarSize } from '../base/avatar/avatar-props'

interface Props {
  member: AvatarMemberAttributes
  type?: 'to' | 'from' | 'self'
  size?: AvatarSize
}

const { size = '40' } = defineProps<Props>()

const sizeClasses = computed(() => {
  if (size == '160') {
    return 'h-[128px] w-[128px]'
  }
  if (size == '80') {
    return 'h-[88px] w-[88px]'
  }
  if (size == '64') {
    return 'h-[72px] w-[72px]'
  }
  if (size == '32') {
    return 'w-10 h-10'
  }
  if (size == '24') {
    return 'w-8 h-8'
  }
  return 'w-12 h-12'
})
</script>
